import { render, staticRenderFns } from "./SupplierFrom.vue?vue&type=template&id=20c2b58b&scoped=true&"
import script from "./SupplierFrom.vue?vue&type=script&lang=js&"
export * from "./SupplierFrom.vue?vue&type=script&lang=js&"
import style0 from "./SupplierFrom.vue?vue&type=style&index=0&id=20c2b58b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c2b58b",
  null
  
)

export default component.exports